/**
 * Formats numbers into Indian number system (lakhs and crores)
 * Example: 223920 -> 2,23,920
 */
function formatIndianNumber(num) {
  const numStr = num.toString();
  const lastThree = numStr.substring(numStr.length - 3);
  const otherNumbers = numStr.substring(0, numStr.length - 3);

  if (otherNumbers !== '') {
    return (
      otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') +
      ',' +
      lastThree
    );
  }
  return lastThree;
}

function formatPriceTextFromCents(priceInCents) {
  const numericPrice = Number(priceInCents);

  if (Number.isNaN(numericPrice)) {
    return '';
  }

  const rupees = numericPrice / 100;
  const [wholePart, decimalPart] = rupees.toFixed(2).split('.');
  const formattedWholePart = formatIndianNumber(wholePart);

  if (decimalPart === '00') {
    return `Rs. ${formattedWholePart}`;
  }

  return `Rs. ${formattedWholePart}.${decimalPart}`;
}

function getCurrentProductPriceText() {
  const priceSourceSelectors = [
    '.product-page--featured-blocks .product-price--original',
    '.product_info_right .product-price--original',
    '#sellingPriceNew'
  ];

  for (const selector of priceSourceSelectors) {
    const sourceEl = document.querySelector(selector);

    if (sourceEl && sourceEl.textContent.trim()) {
      return sourceEl.textContent.trim();
    }
  }

  return '';
}

function updateStickyVariantPrices(priceInCents = null) {
  const formattedPriceText =
    priceInCents !== null && priceInCents !== undefined
      ? formatPriceTextFromCents(priceInCents)
      : getCurrentProductPriceText();

  if (!formattedPriceText) {
    return;
  }

  document.querySelectorAll('.Variant-price-update-new').forEach(el => {
    el.textContent = `: ${formattedPriceText}`;
  });

  document.querySelectorAll('.Variant-price-update').forEach(el => {
    el.textContent = `: ${formattedPriceText}`;
  });

  document.querySelectorAll('.mobileVPrice').forEach(el => {
    el.textContent = formattedPriceText;
  });
}

/**
 * Main function
 * - Normal call → formats [data-format="true"]
 * - With price → ALSO updates .Variant-price-update
 */
function formatAllPrices(passedPrice = null) {

  /* =====================================
     ✅ ADDITIONAL FEATURE (OPTIONAL)
     Variant price update (NO LOGIC CHANGE)
  ====================================== */
  if (passedPrice !== null && passedPrice !== undefined) {
    updateStickyVariantPrices(passedPrice);
  }

  /* =====================================
     🔒 ORIGINAL FUNCTIONALITY (AS-IS)
  ====================================== */
  const elements = document.querySelectorAll('[data-format="true"]');

  elements.forEach(el => {
    let text = el.textContent.trim();
    const match = text.match(/(Rs\.?\s*)?([\d,]+)/);

    if (match) {
      const currency = match[1] || 'Rs. ';
      const price = match[2].replace(/,/g, '');

      if (!isNaN(price) && price !== '') {
        el.textContent = currency + formatIndianNumber(price);
      }
    }
  });
}


function priceUpdateOnVariantChange(data){
  const mrpPriceNew = document.getElementById('mrpPriceNew');
  const discountPercentageNew = document.getElementById('discountPercentageNew');
  const discountedPriceNew = document.getElementById('discountedPriceNew');
  const sellingPriceNew = document.getElementById('sellingPriceNew');
  const priceCutNew = document.getElementById('priceCutNew');

  // Remove Extra Zero
  const mrpPriceNewFormat = data.compare_at_price / 100 ;
  const actualPriceNewFormate = data.price / 100 ;

  // Calculation Part
  const discountPercentageCalculate = ((mrpPriceNewFormat - actualPriceNewFormate) / mrpPriceNewFormat) * 100;
  const discountedPriceCalculate = mrpPriceNewFormat - actualPriceNewFormate;
  const sellingPriceNewCalculate = mrpPriceNewFormat - discountedPriceCalculate;
  // mrp Price Print
  mrpPriceNew.textContent = `Rs. ${formatIndianNumber(mrpPriceNewFormat)}`;
  discountPercentageNew.textContent = `Base Discount (-${discountPercentageCalculate}%)`;
  discountedPriceNew.textContent = `Rs ${formatIndianNumber(discountedPriceCalculate)}`;
  sellingPriceNew.textContent = `Rs. ${formatIndianNumber(sellingPriceNewCalculate)}`;
  priceCutNew.textContent = formatIndianNumber(mrpPriceNewFormat);
}

/* =====================================
   Run on page load
===================================== */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    formatAllPrices();
    updateStickyVariantPrices();
  });
} else {
  formatAllPrices();
  updateStickyVariantPrices();
}

/* =====================================
   Variant update listener
===================================== */
document.addEventListener('DOMContentLoaded', function () {
  const productRoots = document.querySelectorAll('[data-product-id]');

  productRoots.forEach(root => {
    root.addEventListener('variantUpdated', function (event) {
      formatAllPrices(event.detail.price);
      priceUpdateOnVariantChange(event.detail);
    });
  });
});

/* =====================================
   Expose globally
===================================== */
window.formatAllPrices = formatAllPrices;
